<template>
  <div class="toolbarWrapper">
    <div class="toolbar">
      <div class="toolbarContainer">
        <div class="toolbarPart">
          <add-new-element @emit="emitEvent" v-if="options.elements.includes('add')"
                                   :options="options.elementsOptions.add"></add-new-element>
          <filter-element @emit="emitEvent" v-if="options.elements.includes('filter')"
                          :options="options.elementsOptions.filter"></filter-element>
          <files-element @emit="emitEvent" v-if="options.elements.includes('files')"
                         :options="options.elementsOptions.files"></files-element>
          <calendar-element @emit="emitEvent" v-if="options.elements.includes('calendar')"
                            :extraOptions="extraOptions"
                            :options="options.elementsOptions.calendar"></calendar-element>
          <extend-element @emit="emitEvent" v-if="options.elements.includes('extend')"
                          :options="options.elementsOptions.extend"></extend-element>
        </div>
        <div class="toolbarPart pageTitle">
          {{pageTitle}}
        </div>
        <div class="toolbarPart text-left">

          <span v-if="options.elements.includes('quickSearch')">
            <img src="/clientV2/static/gfx/search.svg" id="quick-search-btn" class="iconBtn transition quickSearchOffIcon"
                 v-tippy="{ placement : 'top'}" :title="'חיפוש מהיר'" @click="showQuickSearch">
            <input type="text"
                   id="quick-search-field"
                   class="quickSearch transition quickSearchOff"
                   v-model="quickSearch"
                   @keyup="emitEvent({method: 'quickSearchChange', data: quickSearch})"
                   @keyup.esc="quickSearchBlur"
                   @keyup.enter="quickSearchBlur"
                   @blur="quickSearchBlur">
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import FilesElement from './FilesElement'
  import CalendarElement from './CalendarElement'
  import ExtendElement from './ExtendElement'
  import FilterElement from './FilterElement'
  import AddNewElement from './AddNewElement'

  export default {
    name: 'ToolBar',
    props: ['pageTitle', 'options','extraOptions'],
    components: {AddNewElement, FilesElement, CalendarElement, ExtendElement, FilterElement},
    data() {
      return {
        quickSearch: null
      }
    },
    methods: {
      showQuickSearch: function () {
        document.getElementById('quick-search-btn').classList.remove('quickSearchOffIcon')
        document.getElementById('quick-search-field').classList.remove('quickSearchOff')
        document.getElementById('quick-search-field').focus()
        setTimeout(() => {
          document.getElementById('quick-search-field').selectionStart = document.getElementById('quick-search-field').selectionEnd = 10000
        }, 0)
      },
      quickSearchBlur: function () {
        document.getElementById('quick-search-btn').classList.add('quickSearchOffIcon')
        document.getElementById('quick-search-field').classList.add('quickSearchOff')
      },
      emitEvent: function (data) {
        this.$emit('event', data)
      }
    },
    created() {
    }
  }
</script>
<style lang="less" scoped>
  @import "../../assets/css/style.less";

  .toolbarWrapper {
    display: table;
    height: 110px;
  }

  .toolbar {
    height: 61px;
    position: absolute;
    left: 0;
    width: 100%;
    margin-top: 30px;
    background: #fbfbfb;
    padding: 15px 0px;
    border-bottom: 1px solid @blue-dark;
    box-shadow: 0px 2px 16px 0px rgba(15, 15, 15, .15);
    z-index: 3;
    .toolbarContainer {
      width: 70%;
      display: flex;
      align-content: center;
      margin: auto;
      padding: 0px 15px;
      .pageTitle {
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: @blue-dark;
      }
      .toolbarPart {
        position: relative;
        flex: 1 0;
        .datespan {
          display: inline-block;
          font-size: 15px;
          color: @blue-dark;
        }
        .iconBtn {
          margin-left: 12px;
        }
      }
    }
  }

  .filterMenu {
    position: absolute;
    right: 0px;
    top: 45px;
    text-align: right;
    background: @white;
    border: 1px solid #ccc;
    box-shadow: 1px 1px 16px 0px rgba(15, 15, 15, .15);
    z-index: 1;
    .checkbox {
      label {
        display: block;
      }
      margin: 0;
      padding: 5px 10px 5px 15px;
      border-bottom: 1px solid #ddd;
    }
  }

  .calendarContainer {
    top: 45px;
    width: 230px;
    padding: 0px 8px 8px 8px;
    z-index: 1;
    position: absolute;
    background: @white;
    border: 1px solid #ccc;
    box-shadow: 1px 1px 16px 0px rgba(15, 15, 15, .15);
    .calendarExtra {
      div {
        cursor: pointer;
        padding: 4px;
        border-bottom: 1px solid #ddd;
      }
    }
    .calendarHeader {
      div {
        display: inline-block;
        vertical-align: top;
        padding: 5px;
        text-align: center;
      }
      .year {
        width: 77%;
      }
      .arrow {
        cursor: pointer;
        font-weight: bold;
        width: 10%;
      }
    }
    .monthsContainer {
      border: 1px solid #474747;
      padding: 5px;
      div {
        box-shadow: inset 0px 0px 0px 2px @white;
        width: 33.3%;
        display: inline-block;
        vertical-align: top;
        text-align: center;
        padding: 5px;
        border-bottom: 1px solid #474747;
        cursor: pointer;
        transition: all .3s ease-out;
        &:hover {
          background: #ccc;
        }
        &:nth-of-type(3n-1) {
          border-left: 1px solid #474747;
          border-right: 1px solid #474747;
        }
        &:nth-of-type(10), &:nth-of-type(11), &:nth-of-type(12) {
          border-bottom: none;
        }
      }
    }

    .clearCalendar {
      background: @orange;
      text-align: center;
      padding: 6px 0px;
      color: @white;
      margin-top: 8px;
      cursor: pointer;
    }
  }

  .quickSearch {
    margin-left: 12px;
    background: transparent;
    border: none;
    border-bottom: 1px solid @blue-dark;
    padding-bottom: 5px;
    font-size: 15px;
    margin-right: -6px;
    width: 100px;
    &:focus {
      border: none !important;
      border-bottom: 1px solid @blue-dark !important;
    }
  }

  .quickSearchOffIcon {
    margin-left: 0px !important;
  }

  .quickSearchOff {
    width: 0px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/toolbar/ToolBar.vue